import { QueryResult, useQuery } from "@apollo/client";
import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { cdnUrl } from "../../environments/environments";
import { UI_Button } from "../UI_Components/UI_Button";
import { api_post_data } from "../../environments/api_handler";
import { Typography } from "@mui/material";
import { gql_queries } from "../../models/interface/gql_queries";
import Card from "../../purity/components/Card/Card";
import CardHeader from "../../purity/components/Card/CardHeader";
import { Col, Row } from "react-bootstrap";
import { AddIcon } from "@chakra-ui/icons";
import CardBody from "../../purity/components/Card/CardBody";
import {
  cases_page_singleblock_initial_state,
  CasesPageSingleBlockState,
} from "../../store/reducers/cases_page_block_info.reducer";
import { v4 } from "uuid";

const SingleBlockRows = ({
  overall_information_query,
}: {
  overall_information_query: QueryResult;
}) => {
  const textColor = useColorModeValue("gray.700", "white");
  const bgColor = useColorModeValue("#F8F9FA", "gray.800");
  const nameColor = useColorModeValue("gray.500", "white");

  const [all_blocks, set_all_blocks] = useState<CasesPageSingleBlockState[]>(
    [],
  );

  useEffect(() => {
    const data = overall_information_query.data?.overall_information;

    if (data && data.cases_page_blocks) {
      set_all_blocks(data.cases_page_blocks);
    }
  }, [overall_information_query.data]);

  const navigate = useNavigate();

  return (
    <>
      {all_blocks.map((item, i) => (
        <Box key={i} p="24px" bg={bgColor} my="22px" borderRadius="12px">
          <Flex justify="space-between" w="100%">
            <Flex direction="column" maxWidth="70%">
              <Text color={nameColor} fontSize="md" fontWeight="bold" mb="10px">
                {item.de.title}
              </Text>
              <img
                src={`${cdnUrl}/${item.medias.main_img.url}`}
                className="mb-3"
                style={{
                  width: 100,
                  height: "auto",
                  borderRadius: "1rem",
                }}
              />
              <Text color={textColor} fontSize="sm">
                <strong>ID:</strong> {item.ID.substring(0, 10)}...
              </Text>
            </Flex>
            <Flex
              direction={{ sm: "column", md: "row" }}
              align="flex-start"
              p={{ md: "24px" }}
            >
              <UI_Button
                color="error"
                className="mx-1"
                onClick={async () => {
                  if (!window.confirm("Are you sure?")) return;
                  await api_post_data(
                    "admin/delete_item_overall_information_arr_type",
                    {
                      name: "cases_page_blocks",
                      ID: item.ID,
                    },
                  );
                  await overall_information_query.refetch();
                }}
              >
                <Typography variant="body1">
                  <span className="me-2">
                    <i className="fa-light fa-trash-can" />
                  </span>
                  Xóa
                </Typography>
              </UI_Button>
              <UI_Button
                color="primary"
                className="mx-1"
                onClick={() => navigate(`/manage_cases_page_blocks/${item.ID}`)}
              >
                <Typography variant="body1">
                  <span className="me-2">
                    <i className="fa-light fa-pen" />
                  </span>
                  Sửa
                </Typography>
              </UI_Button>
            </Flex>
          </Flex>
        </Box>
      ))}
    </>
  );
};

export const ManageCasesPageBlocksPage = () => {
  const textColor = useColorModeValue("gray.700", "white");

  const overall_information_query = useQuery(gql_queries.overall_information, {
    fetchPolicy: "cache-and-network",
  });

  return (
    <Flex
      direction="column"
      pt={{ base: "120px", md: "75px" }}
      className="gap-3"
    >
      <Card my={{ lg: "24px" }} me={{ lg: "24px" }}>
        <Flex direction="column">
          <CardHeader py="12px">
            <Row className="justify-content-between w-100 align-items-center">
              <Col xs="auto" className="h-fit">
                <Text
                  color={textColor}
                  me="1rem"
                  fontSize="lg"
                  fontWeight="bold"
                >
                  Quản lý Block trang cases
                </Text>
              </Col>
              <Col xs="auto" className="h-fit">
                <UI_Button
                  color="success"
                  onClick={async () => {
                    const cases_page_blocks: CasesPageSingleBlockState = {
                      ...cases_page_singleblock_initial_state,
                      ID: v4(),
                    };
                    await api_post_data(
                      "admin/edit_overall_information_arr_type",
                      { cases_page_blocks },
                    );
                    await overall_information_query.refetch();
                  }}
                >
                  <AddIcon className="me-2" /> Thêm block
                </UI_Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Flex direction="column" w="100%">
              <SingleBlockRows
                overall_information_query={overall_information_query}
              />
            </Flex>
          </CardBody>
        </Flex>
      </Card>
    </Flex>
  );
};
